import React, { Component } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { navy, white, grey25, coral } from '@zocdoc/branding/colors';
import { breakpoint } from '../../../grid';
import { FontFamily } from '../../../typography';
import { UnstyledLink } from '../../../link';

const DropdownItem = styled.div`
    background-color: ${white};
    border-bottom: 1px solid ${grey25};
    border-left: 4px solid ${props => props.highlight ? coral : 'transparent'};
    box-sizing: border-box;
    color: ${navy};
    cursor: pointer;
    display: block;
    font: 18px/28px ${FontFamily.SharpSansSemibold};
    min-width: 40px;
    padding: 6px 15px 6px 11px;
    text-decoration: none;
    transition: border-color 700ms ease-out;

    &:last-child {
        border-bottom: 1px solid transparent;
    }

    &:hover {
        color: ${navy};
        background-color: ${grey25};
    }
    &:active {
        color: ${white};
        background-color: ${navy};
    }

    ${breakpoint.small} {
        font: 15px/20px ${FontFamily.SharpSansSemibold};
        padding: 8px 15px 8px 11px;
    }
`;

const DropdownLink = DropdownItem.withComponent(UnstyledLink);

export default class DropdownContainer extends Component {
    static propTypes = {
        highlight: PropTypes.bool,
        href: PropTypes.string,
        itemId: PropTypes.any,
        onClick: PropTypes.func,
    };

    static defaultProps = {
        highlight: false,
    };

    render() {
        const {
            children,
            highlight,
            href,
            itemId,
            onClick,
        } = this.props;

        if (href) {
            return (
                <DropdownLink
                    beforeClick={onClick}
                    data-id={itemId}
                    data-test="dropdown-link"
                    highlight={highlight}
                    href={href}
                >
                    {children}
                </DropdownLink>
            );
        } else {
            return (
                <DropdownItem
                    data-id={itemId}
                    data-test="dropdown-item"
                    highlight={highlight}
                    onClick={onClick}
                >
                    {children}
                </DropdownItem>
            );
        }
    }
}
